"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _menu = _interopRequireDefault(require("cccisd-icons/menu7"));
var _arrowLeft = _interopRequireDefault(require("cccisd-icons/arrow-left12"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right12"));
var _cccisdRenderInBody = _interopRequireDefault(require("cccisd-render-in-body"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var animationTime = Number(_style["default"].animationTime.replace('ms', ''));
var contentWidth = _style["default"].contentWidth;
var SideMenu = function SideMenu(_ref) {
  var renderCloseButton = _ref.renderCloseButton,
    renderTabs = _ref.renderTabs,
    slideInFrom = _ref.slideInFrom,
    tabs = _ref.tabs,
    trigger = _ref.trigger;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSliding = _useState2[0],
    setIsSliding = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isExpanded = _useState4[0],
    setIsExpanded = _useState4[1];
  (0, _react.useEffect)(function () {
    var reactApp = document.querySelector('#app').style;
    if (isExpanded) {
      reactApp.maxHeight = '100vh';
      reactApp.overflow = 'hidden';
      setIsSliding(true);
    } else {
      reactApp.maxHeight = 'initial';
      reactApp.overflow = 'auto';
    }
  }, [isExpanded]);
  (0, _react.useEffect)(function () {
    if (!isSliding) {
      setTimeout(function () {
        setIsExpanded(false);
      }, animationTime);
    }
  }, [isSliding]);
  function handleClickOutside(event) {
    if (event.target.isSameNode(event.currentTarget)) {
      setIsSliding(false);
    }
  }
  function closeNavigation() {
    setIsSliding(false);
  }
  function defaultRenderCloseButton() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].defaultCloseButton,
      style: {
        textAlign: slideInFrom
      }
    }, /*#__PURE__*/_react["default"].createElement("button", {
      className: "btn btn-secondary",
      onClick: closeNavigation,
      type: "button"
    }, slideInFrom === 'left' ? /*#__PURE__*/_react["default"].createElement(_arrowLeft["default"], null) : /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], null)));
  }
  function defaultRenderTabs() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].defaultTabs
    }, !Array.isArray(tabs) || tabs.length === 0 ? /*#__PURE__*/_react["default"].createElement("p", {
      className: _style["default"].noTabsMsg
    }, /*#__PURE__*/_react["default"].createElement("i", null, "No menu to show at this time.")) : /*#__PURE__*/_react["default"].createElement("ul", {
      className: "nav nav-pills nav-stacked"
    }, tabs.map(function (tab, i) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        role: "presentation",
        key: i,
        className: "".concat(tab.isActive ? 'active' : '', " ").concat(tab.isDisabled ? 'disabled' : '')
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "#",
        onClick: function onClick() {
          return !tab.isDisabled && tab.onClick({
            closeNavigation: closeNavigation
          });
        }
      }, tab.content));
    })));
  }
  function renderNavigation() {
    var slideInStyles = slideInFrom === 'left' ? {
      borderRadius: '0 5px 5px 0',
      left: 0
    } : {
      borderRadius: '5px 0 0 5px',
      right: 0
    };
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].menuContainer,
      style: {
        width: isExpanded ? '100vw' : '0vw',
        backgroundColor: isSliding ? 'rgba(0, 0, 0, 0.5)' : 'rgba(0, 0, 0, 0)'
      },
      onClick: handleClickOutside
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].menu,
      style: _objectSpread({
        width: isSliding ? contentWidth : '0px'
      }, slideInStyles)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].menuContent
    }, renderCloseButton ? renderCloseButton({
      closeNavigation: closeNavigation
    }) : defaultRenderCloseButton(), renderTabs ? renderTabs({
      tabs: tabs,
      closeNavigation: closeNavigation
    }) : defaultRenderTabs())));
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    onClick: function onClick() {
      return setIsExpanded(true);
    }
  }, trigger), /*#__PURE__*/_react["default"].createElement(_cccisdRenderInBody["default"], null, renderNavigation()));
};
SideMenu.propTypes = {
  renderCloseButton: _propTypes["default"].func,
  renderTabs: _propTypes["default"].func,
  slideInFrom: _propTypes["default"].oneOf(['left', 'right']),
  tabs: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    content: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
    isActive: _propTypes["default"].bool,
    isDisabled: _propTypes["default"].bool,
    onClick: _propTypes["default"].func
  })),
  trigger: _propTypes["default"].node
};
SideMenu.defaultProps = {
  renderCloseButton: null,
  renderTabs: null,
  slideInFrom: 'left',
  tabs: [],
  trigger: /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-secondary",
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement(_menu["default"], null))
};
var _default = exports["default"] = SideMenu;